/**
 * DashboardCreditSegments - segmented credit bar (Plan / Top-ups / free)
 * with a localized legend. Owned by Dashboard Subsystem 2.
 */

import { useTranslation } from 'react-i18next';
import { getLocale } from '@/lib/utils';

interface CreditSegmentsProps {
  plan: number;
  topup: number;
  free: number;
}

export function DashboardCreditSegments({ plan, topup, free }: CreditSegmentsProps) {
  const { t } = useTranslation();
  const fmt = (n: number) => new Intl.NumberFormat(getLocale()).format(n);
  const sum = plan + topup + free;
  const pct = (n: number) => (sum > 0 ? (n / sum) * 100 : 0);

  return (
    <div className="mb-3">
      <div className="flex h-2 rounded-full bg-neutral-100 dark:bg-neutral-800 overflow-hidden">
        <div
          data-testid="dashboard-plan-seg-plan"
          className="h-full bg-primary-500"
          style={{ width: `${pct(plan)}%` }}
        />
        <div
          data-testid="dashboard-plan-seg-topup"
          className="h-full bg-emerald-500"
          style={{ width: `${pct(topup)}%` }}
        />
        <div
          data-testid="dashboard-plan-seg-free"
          className="h-full bg-sky-400"
          style={{ width: `${pct(free)}%` }}
        />
      </div>
      <p
        data-testid="dashboard-plan-legend"
        className="mt-1.5 text-xs text-neutral-500 dark:text-neutral-400"
      >
        {t('dashboardPlan.legend', { x: fmt(plan), y: fmt(topup), z: fmt(free) })}
      </p>
    </div>
  );
}
